import { Route } from '@angular/router';
import { RoutingID } from '../../../sb-routing-enum';
import { management } from './management';
import { plannings } from './plannings';
import { inventory } from './inventory';
import { contentShare } from './content-share';
// import { reservations } from './reservations';
import { SbIcons } from '@ngx-seatback/icons';
import { targeting } from './targeting';
import { CommercialReservationService } from '../../../../services/commercial-reservation.service';

export const assignment: Route = {
  path: 'assignment',
  providers: [CommercialReservationService],
  title: 'nav.assignment',
  data: {
    icon: SbIcons.assignments,
    breadcrumb: 'nav.assignment',
    id: RoutingID.assignment,
  },
  children: [
    management, // campaigns
    plannings,
    contentShare,
    // reservations, // TODO comment in when calendar done
    inventory,
    targeting,
    { path: '', redirectTo: RoutingID.campaigns, pathMatch: 'full' },
  ],
};
